import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import user from 'src/js/modules/user';
import config from 'src/js/modules/config';
import NavbarHeader from 'src/js/common/components/navbar-header';
import MainMenu from 'src/js/common/components/main-menu';

function HelpMenuContainer() {
  const supportUrl = useSelector(user.selectors.getSupportUrl);
  const contactSupportUrl = useSelector(user.selectors.getContactSupportUrl);
  const pricingUrl = useSelector(user.selectors.getPricingUrl);
  const gettingStartedUrl = useSelector(config.selectors.getGettingStartedUrl);
  const publicRoadmapUrl = useSelector(config.selectors.getPublicRoadmapURL);

  const helpMenuItems = useMemo(() => {
    const items = [];

    if (gettingStartedUrl) {
      items.push({
        title: i18next.t('Get started'),
        href: gettingStartedUrl,
        target: '_blank',
      });
    }

    if (supportUrl) {
      items.push({
        title: i18next.t('Help Center'),
        href: supportUrl,
        target: '_blank',
      });
    }

    if (pricingUrl) {
      items.push({
        title: i18next.t('Pricing information'),
        href: pricingUrl,
      });
    }

    if (contactSupportUrl) {
      items.push({
        title: i18next.t('Contact support'),
        href: contactSupportUrl,
        target: '_blank',
      });
    }

    if (publicRoadmapUrl) {
      items.push({
        title: i18next.t('Request a feature'),
        href: publicRoadmapUrl,
        target: '_blank',
      });
    }

    return items;
  }, [pricingUrl, contactSupportUrl, supportUrl, gettingStartedUrl, publicRoadmapUrl]);

  if (helpMenuItems.length) {
    return (
      <React.Fragment>
        <MainMenu
          captions={{
            name: i18next.t('Help'),
          }}
          className="ws-mainmenu--help-menu"
          items={helpMenuItems}
        />
        <NavbarHeader.Divider />
      </React.Fragment>
    );
  }

  return null;
}

export default HelpMenuContainer;
